import { DanaPackingSlipResult, getDanaPackingSlipNumber, RequestSlipNumberApi } from "@dana/Services/DanaOrderRelatedService";
import {DanaPackingSlipActions} from "@dana/Store/Data/OrderHistory/Reducers/GetDanaPackingSlipReducer";
import { OrderPackingSlip } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess   
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type RequestSlipNumber = {
    requestNumber?: string;  
}& HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<RequestSlipNumber,RequestSlipNumberApi,DanaPackingSlipResult, DispatchProp<DanaPackingSlipActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "DanaPackingSlip/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getDanaPackingSlipNumber({
        requestNumber:props.parameter.requestNumber,        
    });   
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "DanaPackingSlip/PopulateResult",              
            data: props.apiResult,
        } as any);
    }
}

export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "DanaPackingSlip/Reset",
        isLoading: false,
    });
}

export const chain = [SetLoadingOn,SendDataToApi, PopulateFacetResult];

const GetDanaPackingSlipNumberData = createHandlerChainRunner(chain, "GetDanaPackingSlipNumberData");
export default GetDanaPackingSlipNumberData;